import { isUndefined } from "lodash"
import { Route } from "react-router-dom"
import { CustomRoute } from "../main/routing/CustomRoute"
class AppRoutesUtil {

    static generatedRoutes: Array<JSX.Element> = []

    static defaultUrl: string = ""

    static buildRoute(customRoute: CustomRoute, parentPath: string = ""): Array<JSX.Element> {

        const routePath = parentPath + "/" + customRoute.path

        let routeComponent: Array<JSX.Element> = isUndefined(customRoute.component) ? [] : [<Route path={routePath} element={<customRoute.component />} key={routePath} />]

        customRoute.childrens.forEach((route: CustomRoute) => {

            const childRouteComponent = this.buildRoute(route, routePath)

            routeComponent.push(...childRouteComponent)
        })

        return routeComponent
    }

    static generateRoutesFromCustomRoutes(customRoutes: Array<CustomRoute>, defaultUrl: string) {

        // console.log(">>>>>>>>> >>>>>>>>> >>>>>>>>> generateRoutesFromCustomRoutes");
        // console.log("customRoutes", customRoutes);
        // console.log("defaultUrl", defaultUrl);

        this.resetRoutes()

        this.defaultUrl = defaultUrl

        customRoutes.forEach((route: CustomRoute) => this.generatedRoutes.push(...this.buildRoute(route)))

        // console.log("generatedRoutes", this.generatedRoutes.map((e) => e));
        // console.log(">>>>>>>>> >>>>>>>>> >>>>>>>>>");
    }

    static resetRoutes(): void {
        this.generatedRoutes = []
        this.defaultUrl = ""
    }
}

export default AppRoutesUtil